import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  Json: any;
  Upload: any;
};

export type AuthenticateResponse = {
  __typename?: 'AuthenticateResponse';
  token: Scalars['String'];
};

export type ChildrenId = {
  id?: InputMaybe<Scalars['String']>;
};

export type City = {
  __typename?: 'City';
  country: Country;
  id: Scalars['String'];
  latitude: Scalars['Decimal'];
  longitude: Scalars['Decimal'];
  name: Scalars['String'];
  state: State;
  type: Scalars['String'];
};

export type CityFilter = {
  AND?: InputMaybe<Array<CityFilter>>;
  NOT?: InputMaybe<Array<CityFilter>>;
  OR?: InputMaybe<Array<CityFilter>>;
  country?: InputMaybe<CountryFilter>;
  id?: InputMaybe<FilterString>;
  municipality?: InputMaybe<FilterString>;
  name?: InputMaybe<FilterString>;
  state?: InputMaybe<StateFilter>;
  type?: InputMaybe<FilterString>;
};

export type CitySortOrder = {
  country?: InputMaybe<CountrySortOrder>;
  id?: InputMaybe<SortOrder>;
  municipality?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  state?: InputMaybe<StateSortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ColumnInfo = {
  __typename?: 'ColumnInfo';
  columnName: Scalars['String'];
  isHidden: Scalars['Boolean'];
  sortingEnabled: Scalars['Boolean'];
  width: Scalars['Decimal'];
};

export type ColumnInfoInput = {
  columnName: Scalars['String'];
  isHidden: Scalars['Boolean'];
  sortingEnabled: Scalars['Boolean'];
  width: Scalars['Decimal'];
};

export type Confidence = {
  __typename?: 'Confidence';
  id: Scalars['String'];
  name_en: Scalars['String'];
  name_es: Scalars['String'];
  name_pt: Scalars['String'];
};

export type ConfidenceFilter = {
  AND?: InputMaybe<Array<ConfidenceFilter>>;
  NOT?: InputMaybe<Array<ConfidenceFilter>>;
  OR?: InputMaybe<Array<ConfidenceFilter>>;
  id?: InputMaybe<FilterString>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
};

export type ConfidenceSortOrder = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type ConfidenceSortOrderRelated = {
  _count?: InputMaybe<SortOrder>;
};

export type Country = {
  __typename?: 'Country';
  id: Scalars['String'];
  latitude: Scalars['Decimal'];
  longitude: Scalars['Decimal'];
  name: Scalars['String'];
};

export type CountryFilter = {
  AND?: InputMaybe<Array<CountryFilter>>;
  NOT?: InputMaybe<Array<CountryFilter>>;
  OR?: InputMaybe<Array<CountryFilter>>;
  id?: InputMaybe<FilterString>;
  name?: InputMaybe<FilterString>;
};

export type CountrySortOrder = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type CreateEventImage = {
  description?: InputMaybe<Scalars['String']>;
  file: Scalars['String'];
  ticket: Scalars['String'];
};

export type CreateReferenceLink = {
  description?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
};

export type DependentRolesUpdate = {
  add?: InputMaybe<Array<UserRole>>;
  remove?: InputMaybe<Array<UserRole>>;
};

export type Event = {
  __typename?: 'Event';
  author: User;
  city?: Maybe<City>;
  confidence?: Maybe<Confidence>;
  content?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  detailedLocation?: Maybe<Scalars['String']>;
  eventTime: Scalars['DateTime'];
  eventTypes: Array<EventType>;
  hailMaxDiameterMM?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  images?: Maybe<Array<EventImage>>;
  impacts?: Maybe<Array<Impact>>;
  latitude?: Maybe<Scalars['Decimal']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Decimal']>;
  miscellany?: Maybe<Scalars['String']>;
  precipitationAccumMM?: Maybe<Scalars['Float']>;
  references?: Maybe<Array<ReferenceLink>>;
  reviewer?: Maybe<User>;
  snowAccumMM?: Maybe<Scalars['Float']>;
  source: InformationSource;
  spacialPrecisionMeters?: Maybe<Scalars['Int']>;
  state?: Maybe<State>;
  temporalPrecisionSeg?: Maybe<Scalars['Int']>;
  totalDurationSeg?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validated?: Maybe<Scalars['Boolean']>;
  windDirectionDegrees?: Maybe<Scalars['Float']>;
  windSpeedKmH?: Maybe<Scalars['Float']>;
  windSpeedMaxKmH?: Maybe<Scalars['Float']>;
};

export type EventFilter = {
  AND?: InputMaybe<Array<EventFilter>>;
  NOT?: InputMaybe<Array<EventFilter>>;
  OR?: InputMaybe<Array<EventFilter>>;
  author?: InputMaybe<UserFilter>;
  city?: InputMaybe<CityFilter>;
  confidence?: InputMaybe<ConfidenceFilter>;
  content?: InputMaybe<FilterString>;
  country?: InputMaybe<CountryFilter>;
  description?: InputMaybe<FilterString>;
  detailedLocation?: InputMaybe<FilterString>;
  eventTime?: InputMaybe<FilterString>;
  eventTypes?: InputMaybe<EventTypeFilterRelated>;
  hailMaxDiameterMM?: InputMaybe<FilterFloat>;
  id?: InputMaybe<FilterString>;
  images?: InputMaybe<EventImageFilterRelated>;
  impacts?: InputMaybe<ImpactsFilterRelated>;
  latitude?: InputMaybe<FilterFloat>;
  location?: InputMaybe<FilterString>;
  longitude?: InputMaybe<FilterFloat>;
  miscellany?: InputMaybe<FilterString>;
  references?: InputMaybe<ReferenceLinkFilterRelated>;
  reviewer?: InputMaybe<UserFilter>;
  source?: InputMaybe<InformationSourceFilter>;
  spacialPrecisionMeters?: InputMaybe<FilterInt>;
  state?: InputMaybe<StateFilter>;
  temporalPrecisionSeg?: InputMaybe<FilterInt>;
  totalDurationSeg?: InputMaybe<FilterInt>;
  validated?: InputMaybe<Scalars['Boolean']>;
};

export type EventImage = {
  __typename?: 'EventImage';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type EventImageFilter = {
  AND?: InputMaybe<Array<EventImageFilter>>;
  NOT?: InputMaybe<Array<EventImageFilter>>;
  OR?: InputMaybe<Array<EventImageFilter>>;
  description?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  name?: InputMaybe<FilterString>;
};

export type EventImageFilterRelated = {
  every?: InputMaybe<EventImageFilter>;
  is?: InputMaybe<Scalars['String']>;
  isNot?: InputMaybe<Scalars['String']>;
  none?: InputMaybe<EventImageFilter>;
  some?: InputMaybe<EventImageFilter>;
};

export type EventImageSortOrder = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type EventImageSortOrderRelated = {
  _count?: InputMaybe<SortOrder>;
};

export type EventOrderBy = {
  author?: InputMaybe<UserSortOrder>;
  city?: InputMaybe<CitySortOrder>;
  confidence?: InputMaybe<ConfidenceSortOrder>;
  content?: InputMaybe<SortOrder>;
  country?: InputMaybe<CountrySortOrder>;
  description?: InputMaybe<SortOrder>;
  detailedLocation?: InputMaybe<SortOrder>;
  eventTime?: InputMaybe<SortOrder>;
  eventTypes?: InputMaybe<EventTypeSortOrderRelated>;
  hailMaxDiameterMM?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  images?: InputMaybe<EventImageSortOrderRelated>;
  impacts?: InputMaybe<ImpactSortOrderRelated>;
  latitude?: InputMaybe<SortOrder>;
  location?: InputMaybe<SortOrder>;
  longitude?: InputMaybe<SortOrder>;
  miscellany?: InputMaybe<SortOrder>;
  references?: InputMaybe<ConfidenceSortOrderRelated>;
  reviewer?: InputMaybe<UserSortOrder>;
  source?: InputMaybe<InformationSourceSortOrder>;
  spacialPrecisionMeters?: InputMaybe<SortOrder>;
  state?: InputMaybe<StateSortOrder>;
  temporalPrecisionSeg?: InputMaybe<SortOrder>;
  totalDurationSeg?: InputMaybe<SortOrder>;
  validated?: InputMaybe<SortOrder>;
};

export type EventType = {
  __typename?: 'EventType';
  description_en: Scalars['String'];
  description_es: Scalars['String'];
  description_pt: Scalars['String'];
  id: Scalars['String'];
  name_en: Scalars['String'];
  name_es: Scalars['String'];
  name_pt: Scalars['String'];
};

export type EventTypeFilter = {
  AND?: InputMaybe<Array<OrganizationFilter>>;
  NOT?: InputMaybe<Array<OrganizationFilter>>;
  OR?: InputMaybe<Array<OrganizationFilter>>;
  description_en?: InputMaybe<FilterString>;
  description_es?: InputMaybe<FilterString>;
  description_pt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
};

export type EventTypeFilterRelated = {
  every?: InputMaybe<EventTypeFilter>;
  is?: InputMaybe<Scalars['String']>;
  isNot?: InputMaybe<Scalars['String']>;
  none?: InputMaybe<EventTypeFilter>;
  some?: InputMaybe<EventTypeFilter>;
};

export type EventTypeSortOrder = {
  description_en?: InputMaybe<SortOrder>;
  description_es?: InputMaybe<SortOrder>;
  description_pt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type EventTypeSortOrderRelated = {
  _count?: InputMaybe<SortOrder>;
};

export type File = {
  __typename?: 'File';
  encoding: Scalars['String'];
  filename: Scalars['String'];
  mimetype: Scalars['String'];
  ticket: Scalars['String'];
};

export type FilterBoolean = {
  equals?: InputMaybe<Scalars['Boolean']>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<Scalars['Boolean']>;
};

export type FilterDate = {
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  range?: InputMaybe<Scalars['String']>;
  regex?: InputMaybe<Scalars['String']>;
};

export type FilterDecimal = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<Scalars['Decimal']>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type FilterFloat = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<Scalars['Float']>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FilterInt = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export enum FilterMode {
  Insensitive = 'insensitive'
}

export type FilterString = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
  isNull?: InputMaybe<Scalars['Boolean']>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<FilterMode>;
  not?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  range?: InputMaybe<Scalars['String']>;
  regex?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type FilterStringList = {
  equals?: InputMaybe<Scalars['String']>;
  has?: InputMaybe<Scalars['String']>;
  hasEvery?: InputMaybe<Array<Scalars['String']>>;
  hasSome?: InputMaybe<Array<Scalars['String']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type Impact = {
  __typename?: 'Impact';
  id: Scalars['String'];
  impactType: ImpactType;
  name_en: Scalars['String'];
  name_es: Scalars['String'];
  name_pt: Scalars['String'];
};

export type ImpactFilter = {
  AND?: InputMaybe<Array<ImpactFilter>>;
  NOT?: InputMaybe<Array<ImpactFilter>>;
  OR?: InputMaybe<Array<ImpactFilter>>;
  id?: InputMaybe<FilterString>;
  impactType?: InputMaybe<ImpactTypeFilter>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
};

export type ImpactSortOrder = {
  id?: InputMaybe<SortOrder>;
  impactType?: InputMaybe<ImpactTypeSortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type ImpactSortOrderRelated = {
  _count?: InputMaybe<SortOrder>;
};

export type ImpactType = {
  __typename?: 'ImpactType';
  id: Scalars['String'];
  name_en: Scalars['String'];
  name_es: Scalars['String'];
  name_pt: Scalars['String'];
};

export type ImpactTypeFilter = {
  AND?: InputMaybe<Array<OrganizationFilter>>;
  NOT?: InputMaybe<Array<OrganizationFilter>>;
  OR?: InputMaybe<Array<OrganizationFilter>>;
  id?: InputMaybe<FilterString>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
};

export type ImpactTypeSortOrder = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type ImpactsFilterRelated = {
  every?: InputMaybe<ImpactFilter>;
  is?: InputMaybe<Scalars['String']>;
  isNot?: InputMaybe<Scalars['String']>;
  none?: InputMaybe<ImpactFilter>;
  some?: InputMaybe<ImpactFilter>;
};

export type InformationSource = {
  __typename?: 'InformationSource';
  id: Scalars['String'];
  name_en: Scalars['String'];
  name_es: Scalars['String'];
  name_pt: Scalars['String'];
};

export type InformationSourceFilter = {
  AND?: InputMaybe<Array<InformationSourceFilter>>;
  NOT?: InputMaybe<Array<InformationSourceFilter>>;
  OR?: InputMaybe<Array<InformationSourceFilter>>;
  id?: InputMaybe<FilterString>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
};

export type InformationSourceSortOrder = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export type InputMultipleRef = {
  add?: InputMaybe<Array<Scalars['String']>>;
  remove?: InputMaybe<Array<Scalars['String']>>;
};

export type ListProfile = {
  __typename?: 'ListProfile';
  VERSION: Scalars['String'];
  columnOrder?: Maybe<Array<Scalars['String']>>;
  columnsInfo?: Maybe<Array<ColumnInfo>>;
  filter?: Maybe<Scalars['Json']>;
  sorting?: Maybe<Array<Sorting>>;
};

export type ListProfileInput = {
  VERSION: Scalars['String'];
  columnOrder?: InputMaybe<Array<Scalars['String']>>;
  columnsInfo?: InputMaybe<Array<ColumnInfoInput>>;
  filter?: InputMaybe<Scalars['Json']>;
  sorting?: InputMaybe<Array<SortingInput>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']>;
  confidenceCreate: Confidence;
  confidenceUpdate: Confidence;
  deleteUploadedFile: Scalars['String'];
  eventCreate: Event;
  eventDeleted: Event;
  eventImageCreate: EventImage;
  eventImageDelete: EventImage;
  eventImageFileUpload: File;
  eventImageUpdate: EventImage;
  eventReviewed: Event;
  eventTypeCreate: EventType;
  eventTypeUpdate: EventType;
  eventUpdate: Event;
  impactCreate: Impact;
  impactTypeCreate: ImpactType;
  impactTypeUpdate: ImpactType;
  impactUpdate: Impact;
  informationSourceCreate: InformationSource;
  informationSourceUpdate: InformationSource;
  organizationCreate: Organization;
  organizationUpdate: Organization;
  referenceLinkCreate: ReferenceLink;
  referenceLinkUpdate: ReferenceLink;
  saveProfile: Scalars['Boolean'];
  singleUpload: File;
  userChangePassword: User;
  userCreate: User;
  userResetPassword: User;
  userUpdate: User;
  userUpdateProfile: User;
};


export type MutationConfidenceCreateArgs = {
  id: Scalars['String'];
  name_en: Scalars['String'];
  name_es: Scalars['String'];
  name_pt: Scalars['String'];
};


export type MutationConfidenceUpdateArgs = {
  id: Scalars['String'];
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_pt?: InputMaybe<Scalars['String']>;
};


export type MutationDeleteUploadedFileArgs = {
  ticket: Scalars['String'];
};


export type MutationEventCreateArgs = {
  cityId?: InputMaybe<Scalars['String']>;
  confidenceId?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  detailedLocation?: InputMaybe<Scalars['String']>;
  eventTime: Scalars['DateTime'];
  eventTypes: Array<Scalars['String']>;
  hailMaxDiameterMM?: InputMaybe<Scalars['Float']>;
  images?: InputMaybe<Array<CreateEventImage>>;
  impacts?: InputMaybe<Array<Scalars['String']>>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  location?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  miscellany?: InputMaybe<Scalars['String']>;
  precipitationAccumMM?: InputMaybe<Scalars['Float']>;
  references?: InputMaybe<Array<CreateReferenceLink>>;
  snowAccumMM?: InputMaybe<Scalars['Float']>;
  sourceId: Scalars['String'];
  spacialPrecisionMeters?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['String']>;
  temporalPrecisionSeg?: InputMaybe<Scalars['Int']>;
  totalDurationSeg?: InputMaybe<Scalars['Int']>;
  windDirectionDegrees?: InputMaybe<Scalars['Float']>;
  windSpeedKmH?: InputMaybe<Scalars['Float']>;
  windSpeedMaxKmH?: InputMaybe<Scalars['Float']>;
};


export type MutationEventDeletedArgs = {
  id: Scalars['String'];
};


export type MutationEventImageCreateArgs = {
  description?: InputMaybe<Scalars['String']>;
  file: Scalars['String'];
};


export type MutationEventImageDeleteArgs = {
  id: Scalars['String'];
};


export type MutationEventImageFileUploadArgs = {
  upload: Scalars['Upload'];
};


export type MutationEventImageUpdateArgs = {
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};


export type MutationEventReviewedArgs = {
  id: Scalars['String'];
};


export type MutationEventTypeCreateArgs = {
  description_en: Scalars['String'];
  description_es: Scalars['String'];
  description_pt: Scalars['String'];
  id: Scalars['String'];
  name_en: Scalars['String'];
  name_es: Scalars['String'];
  name_pt: Scalars['String'];
};


export type MutationEventTypeUpdateArgs = {
  id: Scalars['String'];
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_pt?: InputMaybe<Scalars['String']>;
};


export type MutationEventUpdateArgs = {
  cityId?: InputMaybe<Scalars['String']>;
  confidenceId?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  detailedLocation?: InputMaybe<Scalars['String']>;
  eventTime?: InputMaybe<Scalars['DateTime']>;
  eventTypes?: InputMaybe<Array<Scalars['String']>>;
  hailMaxDiameterMM?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  images?: InputMaybe<UpdateImagesChildren>;
  impacts?: InputMaybe<Array<Scalars['String']>>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  location?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  miscellany?: InputMaybe<Scalars['String']>;
  precipitationAccumMM?: InputMaybe<Scalars['Float']>;
  references?: InputMaybe<UpdateReferenceChildren>;
  snowAccumMM?: InputMaybe<Scalars['Float']>;
  sourceId?: InputMaybe<Scalars['String']>;
  spacialPrecisionMeters?: InputMaybe<Scalars['Int']>;
  stateId?: InputMaybe<Scalars['String']>;
  temporalPrecisionSeg?: InputMaybe<Scalars['Int']>;
  totalDurationSeg?: InputMaybe<Scalars['Int']>;
  windDirectionDegrees?: InputMaybe<Scalars['Float']>;
  windSpeedKmH?: InputMaybe<Scalars['Float']>;
  windSpeedMaxKmH?: InputMaybe<Scalars['Float']>;
};


export type MutationImpactCreateArgs = {
  id: Scalars['String'];
  impactTypeId: Scalars['String'];
  name_en: Scalars['String'];
  name_es: Scalars['String'];
  name_pt: Scalars['String'];
};


export type MutationImpactTypeCreateArgs = {
  id: Scalars['String'];
  name_en: Scalars['String'];
  name_es: Scalars['String'];
  name_pt: Scalars['String'];
};


export type MutationImpactTypeUpdateArgs = {
  id: Scalars['String'];
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_pt?: InputMaybe<Scalars['String']>;
};


export type MutationImpactUpdateArgs = {
  id: Scalars['String'];
  impactTypeId?: InputMaybe<Scalars['String']>;
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_pt?: InputMaybe<Scalars['String']>;
};


export type MutationInformationSourceCreateArgs = {
  id: Scalars['String'];
  name_en: Scalars['String'];
  name_es: Scalars['String'];
  name_pt: Scalars['String'];
};


export type MutationInformationSourceUpdateArgs = {
  id: Scalars['String'];
  name_en?: InputMaybe<Scalars['String']>;
  name_es?: InputMaybe<Scalars['String']>;
  name_pt?: InputMaybe<Scalars['String']>;
};


export type MutationOrganizationCreateArgs = {
  countryId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  webpage?: InputMaybe<Scalars['String']>;
};


export type MutationOrganizationUpdateArgs = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  webpage?: InputMaybe<Scalars['String']>;
};


export type MutationReferenceLinkCreateArgs = {
  description?: InputMaybe<Scalars['String']>;
  event_id: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  link: Scalars['String'];
};


export type MutationReferenceLinkUpdateArgs = {
  description: Scalars['String'];
  id: Scalars['String'];
  link?: InputMaybe<Scalars['String']>;
};


export type MutationSaveProfileArgs = {
  key: Array<Scalars['String']>;
  value: Scalars['Json'];
};


export type MutationSingleUploadArgs = {
  file: Scalars['Upload'];
};


export type MutationUserChangePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationUserCreateArgs = {
  active: Scalars['Boolean'];
  email: Scalars['String'];
  name: Scalars['String'];
  organizations: Array<Scalars['String']>;
  roles: Array<UserRole>;
};


export type MutationUserResetPasswordArgs = {
  id: Scalars['String'];
};


export type MutationUserUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<OrganizationsUpdate>;
  roles?: InputMaybe<DependentRolesUpdate>;
};


export type MutationUserUpdateProfileArgs = {
  profile: UserProfileInput;
};

export type OrderBy = {
  field: Scalars['String'];
  sortOrder?: InputMaybe<SortOrder>;
};

export type Organization = {
  __typename?: 'Organization';
  country: Country;
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  users?: Maybe<Array<Maybe<User>>>;
  webpage: Scalars['String'];
};

export type OrganizationFilter = {
  AND?: InputMaybe<Array<OrganizationFilter>>;
  NOT?: InputMaybe<Array<OrganizationFilter>>;
  OR?: InputMaybe<Array<OrganizationFilter>>;
  country?: InputMaybe<CountryFilter>;
  description?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  name?: InputMaybe<FilterString>;
  user?: InputMaybe<UserFilter>;
};

export type OrganizationFilterRelated = {
  every?: InputMaybe<OrganizationFilter>;
  is?: InputMaybe<Scalars['String']>;
  isNot?: InputMaybe<Scalars['String']>;
  none?: InputMaybe<OrganizationFilter>;
  some?: InputMaybe<OrganizationFilter>;
};

export type OrganizationSortOrder = {
  country?: InputMaybe<CountrySortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserSortOrder>;
};

export type OrganizationsUpdate = {
  add?: InputMaybe<Array<Scalars['String']>>;
  remove?: InputMaybe<Array<Scalars['String']>>;
};

export type Permission = {
  __typename?: 'Permission';
  id: Scalars['String'];
  name_en: Scalars['String'];
  name_es: Scalars['String'];
  name_pt: Scalars['String'];
};

export type PermissionFilter = {
  AND?: InputMaybe<Array<PermissionFilter>>;
  NOT?: InputMaybe<Array<PermissionFilter>>;
  OR?: InputMaybe<Array<PermissionFilter>>;
  id?: InputMaybe<FilterString>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']>;
  cityPage: Array<City>;
  confidenceAll: Array<Confidence>;
  countryAll: Array<Country>;
  eventImageAll: Array<Maybe<EventImage>>;
  eventImageOne: EventImage;
  eventList: Array<Maybe<Event>>;
  eventOne: Event;
  eventTypeAll: Array<EventType>;
  impactAll: Array<Impact>;
  impactTypeAll: Array<ImpactType>;
  informationSourceAll: Array<InformationSource>;
  login: AuthenticateResponse;
  me: User;
  organizationList: Array<Organization>;
  permissionAll: Array<Permission>;
  referenceLinkAll: Array<ReferenceLink>;
  roleList: Array<Role>;
  stateAll: Array<State>;
  userList: Array<Maybe<User>>;
  userOne: User;
};


export type QueryCityPageArgs = {
  lastId?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CityFilter>;
};


export type QueryConfidenceAllArgs = {
  where?: InputMaybe<ConfidenceFilter>;
};


export type QueryCountryAllArgs = {
  where?: InputMaybe<CountryFilter>;
};


export type QueryEventImageAllArgs = {
  where?: InputMaybe<EventImageFilter>;
};


export type QueryEventImageOneArgs = {
  id: Scalars['String'];
};


export type QueryEventListArgs = {
  lastSortedColumn?: InputMaybe<Scalars['String']>;
  nextValueOfSortedColumn?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<EventOrderBy>>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EventFilter>;
};


export type QueryEventOneArgs = {
  id: Scalars['String'];
};


export type QueryEventTypeAllArgs = {
  where?: InputMaybe<EventTypeFilter>;
};


export type QueryImpactAllArgs = {
  where?: InputMaybe<ImpactFilter>;
};


export type QueryImpactTypeAllArgs = {
  where?: InputMaybe<ImpactTypeFilter>;
};


export type QueryInformationSourceAllArgs = {
  where?: InputMaybe<InformationSourceFilter>;
};


export type QueryLoginArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type QueryOrganizationListArgs = {
  where?: InputMaybe<OrganizationFilter>;
};


export type QueryPermissionAllArgs = {
  where?: InputMaybe<PermissionFilter>;
};


export type QueryReferenceLinkAllArgs = {
  where?: InputMaybe<ReferenceLinkFilter>;
};


export type QueryRoleListArgs = {
  where?: InputMaybe<RoleFilter>;
};


export type QueryStateAllArgs = {
  where?: InputMaybe<StateFilter>;
};


export type QueryUserListArgs = {
  lastSortedColumn?: InputMaybe<Scalars['String']>;
  nextValueOfSortedColumn?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<UserOrderBy>>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserFilter>;
};


export type QueryUserOneArgs = {
  id: Scalars['String'];
};

export type ReferenceLink = {
  __typename?: 'ReferenceLink';
  description?: Maybe<Scalars['String']>;
  event: Event;
  id: Scalars['String'];
  link: Scalars['String'];
};

export type ReferenceLinkFilter = {
  AND?: InputMaybe<Array<ReferenceLinkFilter>>;
  NOT?: InputMaybe<Array<ReferenceLinkFilter>>;
  OR?: InputMaybe<Array<ReferenceLinkFilter>>;
  description?: InputMaybe<FilterString>;
  event?: InputMaybe<EventFilter>;
  id?: InputMaybe<FilterString>;
  link?: InputMaybe<FilterString>;
};

export type ReferenceLinkFilterRelated = {
  every?: InputMaybe<ReferenceLinkFilter>;
  is?: InputMaybe<Scalars['String']>;
  isNot?: InputMaybe<Scalars['String']>;
  none?: InputMaybe<ReferenceLinkFilter>;
  some?: InputMaybe<ReferenceLinkFilter>;
};

export type ReferenceLinkSortOrder = {
  description?: InputMaybe<SortOrder>;
  event?: InputMaybe<EventOrderBy>;
  id?: InputMaybe<SortOrder>;
  link?: InputMaybe<SortOrder>;
};

export type Role = {
  __typename?: 'Role';
  id: UserRole;
  name_en: Scalars['String'];
  name_es: Scalars['String'];
  name_pt: Scalars['String'];
  permissions?: Maybe<Array<Permission>>;
};

export type RoleFilter = {
  AND?: InputMaybe<Array<RoleFilter>>;
  NOT?: InputMaybe<Array<RoleFilter>>;
  OR?: InputMaybe<Array<RoleFilter>>;
  id?: InputMaybe<FilterString>;
  name_en?: InputMaybe<FilterString>;
  name_es?: InputMaybe<FilterString>;
  name_pt?: InputMaybe<FilterString>;
  permissions?: InputMaybe<PermissionFilter>;
};

export type RoleFilterRelated = {
  every?: InputMaybe<RoleFilter>;
  is?: InputMaybe<Scalars['String']>;
  isNot?: InputMaybe<Scalars['String']>;
  none?: InputMaybe<RoleFilter>;
  some?: InputMaybe<RoleFilter>;
};

export type RoleSortOrder = {
  id?: InputMaybe<SortOrder>;
  name_en?: InputMaybe<SortOrder>;
  name_es?: InputMaybe<SortOrder>;
  name_pt?: InputMaybe<SortOrder>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type Sorting = {
  __typename?: 'Sorting';
  columnName: Scalars['String'];
  direction: SortOrder;
};

export type SortingInput = {
  columnName: Scalars['String'];
  direction: SortOrder;
};

export type State = {
  __typename?: 'State';
  country: Country;
  id: Scalars['String'];
  latitude?: Maybe<Scalars['Decimal']>;
  longitude?: Maybe<Scalars['Decimal']>;
  name: Scalars['String'];
};

export type StateFilter = {
  AND?: InputMaybe<Array<StateFilter>>;
  NOT?: InputMaybe<Array<StateFilter>>;
  OR?: InputMaybe<Array<StateFilter>>;
  country?: InputMaybe<CountryFilter>;
  id?: InputMaybe<FilterString>;
  name?: InputMaybe<FilterString>;
};

export type StateSortOrder = {
  country?: InputMaybe<CountrySortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type UpdateEventImage = {
  description?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type UpdateImagesChildren = {
  create?: InputMaybe<Array<CreateEventImage>>;
  delete?: InputMaybe<Array<ChildrenId>>;
  update?: InputMaybe<Array<UpdateEventImage>>;
};

export type UpdateReferenceChildren = {
  create?: InputMaybe<Array<CreateReferenceLink>>;
  delete?: InputMaybe<Array<ChildrenId>>;
  update?: InputMaybe<Array<UpdateReferenceLink>>;
};

export type UpdateReferenceLink = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  link?: InputMaybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  active: Scalars['Boolean'];
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  organizations: Array<Organization>;
  profile?: Maybe<UserProfile>;
  roles: Array<Role>;
};

export type UserFilter = {
  AND?: InputMaybe<Array<UserFilter>>;
  NOT?: InputMaybe<Array<UserFilter>>;
  OR?: InputMaybe<Array<UserFilter>>;
  email?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterString>;
  name?: InputMaybe<FilterString>;
  organizations?: InputMaybe<OrganizationFilterRelated>;
  roles?: InputMaybe<RoleFilterRelated>;
};

export type UserOrderBy = {
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organization?: InputMaybe<OrganizationSortOrder>;
  roles?: InputMaybe<RoleSortOrder>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  listProfile?: Maybe<ListProfile>;
  reviewProfile?: Maybe<ListProfile>;
};

export type UserProfileInput = {
  listProfile?: InputMaybe<ListProfileInput>;
  reviewProfile?: InputMaybe<ListProfileInput>;
};

export enum UserRole {
  Reporter = 'Reporter',
  Reviewer = 'Reviewer',
  SysAdmin = 'SysAdmin',
  UsersAdmin = 'UsersAdmin',
  Viewer = 'Viewer'
}

export type UserSortOrder = {
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  organizations?: InputMaybe<OrganizationSortOrder>;
  role?: InputMaybe<RoleSortOrder>;
};

export type LoginQueryVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginQuery = { __typename?: 'Query', login: { __typename?: 'AuthenticateResponse', token: string } };

export type ChangePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', userChangePassword: { __typename?: 'User', id: string } };

export type UpdateProfileMutationVariables = Exact<{
  profile: UserProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', userUpdateProfile: { __typename?: 'User', id: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, name: string, email: string, organizations: Array<{ __typename?: 'Organization', name: string, country: { __typename?: 'Country', id: string, name: string } }>, roles: Array<{ __typename?: 'Role', id: UserRole, name_en: string, name_es: string, name_pt: string, permissions?: Array<{ __typename?: 'Permission', id: string, name_en: string, name_es: string, name_pt: string }> | null }>, profile?: { __typename?: 'UserProfile', listProfile?: { __typename?: 'ListProfile', columnOrder?: Array<string> | null, filter?: any | null, VERSION: string, columnsInfo?: Array<{ __typename?: 'ColumnInfo', columnName: string, sortingEnabled: boolean, width: any, isHidden: boolean }> | null, sorting?: Array<{ __typename?: 'Sorting', columnName: string, direction: SortOrder }> | null } | null, reviewProfile?: { __typename?: 'ListProfile', columnOrder?: Array<string> | null, filter?: any | null, VERSION: string, columnsInfo?: Array<{ __typename?: 'ColumnInfo', columnName: string, sortingEnabled: boolean, width: any, isHidden: boolean }> | null, sorting?: Array<{ __typename?: 'Sorting', columnName: string, direction: SortOrder }> | null } | null } | null } };

export type SaveProfileMutationVariables = Exact<{
  key: Array<Scalars['String']> | Scalars['String'];
  value: Scalars['Json'];
}>;


export type SaveProfileMutation = { __typename?: 'Mutation', saveProfile: boolean };

export type CitiesQueryVariables = Exact<{
  countryId?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
  nameFragment?: InputMaybe<Scalars['String']>;
  lastId?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
}>;


export type CitiesQuery = { __typename?: 'Query', cityPage: Array<{ __typename?: 'City', id: string, name: string, type: string, latitude: any, longitude: any, state: { __typename?: 'State', name: string, id: string } }> };

export type FileUploadMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type FileUploadMutation = { __typename?: 'Mutation', singleUpload: { __typename?: 'File', ticket: string, filename: string, mimetype: string, encoding: string } };

export type DeleteUploadedFileMutationVariables = Exact<{
  ticket: Scalars['String'];
}>;


export type DeleteUploadedFileMutation = { __typename?: 'Mutation', deleteUploadedFile: string };

export type ConfidencesQueryVariables = Exact<{ [key: string]: never; }>;


export type ConfidencesQuery = { __typename?: 'Query', confidenceAll: Array<{ __typename?: 'Confidence', id: string, name_en: string, name_es: string, name_pt: string }> };

export type NewEventMutationVariables = Exact<{
  eventTime: Scalars['DateTime'];
  sourceId: Scalars['String'];
  eventTypes: Array<Scalars['String']> | Scalars['String'];
  temporalPrecisionSeg?: InputMaybe<Scalars['Int']>;
  totalDurationSeg?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  miscellany?: InputMaybe<Scalars['String']>;
  references?: InputMaybe<Array<CreateReferenceLink> | CreateReferenceLink>;
  impacts?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  images?: InputMaybe<Array<CreateEventImage> | CreateEventImage>;
  confidenceId?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  cityId?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  spacialPrecisionMeters?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  detailedLocation?: InputMaybe<Scalars['String']>;
  hailMaxDiameterMM?: InputMaybe<Scalars['Float']>;
  windSpeedKmH?: InputMaybe<Scalars['Float']>;
  windSpeedMaxKmH?: InputMaybe<Scalars['Float']>;
  windDirectionDegrees?: InputMaybe<Scalars['Float']>;
  precipitationAccumMM?: InputMaybe<Scalars['Float']>;
  snowAccumMM?: InputMaybe<Scalars['Float']>;
}>;


export type NewEventMutation = { __typename?: 'Mutation', eventCreate: { __typename?: 'Event', id: string } };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['String'];
  eventTime?: InputMaybe<Scalars['DateTime']>;
  sourceId?: InputMaybe<Scalars['String']>;
  eventTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  temporalPrecisionSeg?: InputMaybe<Scalars['Int']>;
  totalDurationSeg?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  miscellany?: InputMaybe<Scalars['String']>;
  references?: InputMaybe<UpdateReferenceChildren>;
  impacts?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  images?: InputMaybe<UpdateImagesChildren>;
  confidenceId?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Decimal']>;
  longitude?: InputMaybe<Scalars['Decimal']>;
  cityId?: InputMaybe<Scalars['String']>;
  stateId?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  spacialPrecisionMeters?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['String']>;
  detailedLocation?: InputMaybe<Scalars['String']>;
  hailMaxDiameterMM?: InputMaybe<Scalars['Float']>;
  windSpeedKmH?: InputMaybe<Scalars['Float']>;
  windSpeedMaxKmH?: InputMaybe<Scalars['Float']>;
  windDirectionDegrees?: InputMaybe<Scalars['Float']>;
  precipitationAccumMM?: InputMaybe<Scalars['Float']>;
  snowAccumMM?: InputMaybe<Scalars['Float']>;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', eventUpdate: { __typename?: 'Event', id: string } };

export type DeleteEventMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', eventDeleted: { __typename?: 'Event', id: string, confidence?: { __typename?: 'Confidence', id: string, name_es: string, name_en: string, name_pt: string } | null, reviewer?: { __typename?: 'User', id: string, name: string, email: string } | null } };

export type VerifiedEventMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type VerifiedEventMutation = { __typename?: 'Mutation', eventReviewed: { __typename?: 'Event', id: string, confidence?: { __typename?: 'Confidence', id: string, name_es: string, name_en: string, name_pt: string } | null, reviewer?: { __typename?: 'User', id: string, name: string, email: string } | null } };

export type EventListQueryVariables = Exact<{
  where?: InputMaybe<EventFilter>;
  orderBy?: InputMaybe<Array<EventOrderBy> | EventOrderBy>;
  nextValueOfSortedColumn?: InputMaybe<Scalars['String']>;
  lastSortedColumn?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type EventListQuery = { __typename?: 'Query', eventList: Array<{ __typename?: 'Event', id: string, eventTime: any, temporalPrecisionSeg?: number | null, totalDurationSeg?: number | null, description?: string | null, validated?: boolean | null, latitude?: any | null, longitude?: any | null, spacialPrecisionMeters?: number | null, location?: string | null, detailedLocation?: string | null, hailMaxDiameterMM?: number | null, windSpeedKmH?: number | null, windSpeedMaxKmH?: number | null, windDirectionDegrees?: number | null, precipitationAccumMM?: number | null, snowAccumMM?: number | null, eventTypes: Array<{ __typename?: 'EventType', id: string, name_es: string, name_en: string, name_pt: string }>, references?: Array<{ __typename?: 'ReferenceLink', id: string, link: string, description?: string | null }> | null, impacts?: Array<{ __typename?: 'Impact', id: string, name_es: string, name_en: string, name_pt: string }> | null, source: { __typename?: 'InformationSource', id: string, name_es: string, name_en: string, name_pt: string }, confidence?: { __typename?: 'Confidence', id: string, name_es: string, name_en: string, name_pt: string } | null, images?: Array<{ __typename?: 'EventImage', id: string, name: string, description?: string | null }> | null, author: { __typename?: 'User', name: string, email: string }, reviewer?: { __typename?: 'User', name: string, email: string } | null, city?: { __typename?: 'City', id: string, name: string, type: string, latitude: any, longitude: any, state: { __typename?: 'State', id: string, name: string } } | null, state?: { __typename?: 'State', id: string, name: string } | null, country?: { __typename?: 'Country', id: string, name: string } | null } | null> };

export type GetEventQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEventQuery = { __typename?: 'Query', eventOne: { __typename?: 'Event', id: string, eventTime: any, temporalPrecisionSeg?: number | null, totalDurationSeg?: number | null, description?: string | null, validated?: boolean | null, latitude?: any | null, longitude?: any | null, spacialPrecisionMeters?: number | null, location?: string | null, detailedLocation?: string | null, hailMaxDiameterMM?: number | null, windSpeedKmH?: number | null, windSpeedMaxKmH?: number | null, windDirectionDegrees?: number | null, precipitationAccumMM?: number | null, snowAccumMM?: number | null, eventTypes: Array<{ __typename?: 'EventType', id: string, name_es: string, name_en: string, name_pt: string }>, references?: Array<{ __typename?: 'ReferenceLink', id: string, link: string, description?: string | null }> | null, impacts?: Array<{ __typename?: 'Impact', id: string, name_es: string, name_en: string, name_pt: string }> | null, source: { __typename?: 'InformationSource', id: string, name_es: string, name_en: string, name_pt: string }, confidence?: { __typename?: 'Confidence', id: string, name_es: string, name_en: string, name_pt: string } | null, images?: Array<{ __typename?: 'EventImage', id: string, name: string, description?: string | null }> | null, author: { __typename?: 'User', id: string, name: string, email: string, roles: Array<{ __typename?: 'Role', id: UserRole, name_es: string, name_en: string, name_pt: string }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string, description: string, webpage: string, country: { __typename?: 'Country', name: string } }> }, reviewer?: { __typename?: 'User', id: string, name: string, email: string } | null, city?: { __typename?: 'City', id: string, name: string, type: string, latitude: any, longitude: any, state: { __typename?: 'State', id: string, name: string } } | null, state?: { __typename?: 'State', id: string, name: string } | null, country?: { __typename?: 'Country', id: string, name: string } | null } };

export type EventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type EventTypesQuery = { __typename?: 'Query', eventTypeAll: Array<{ __typename?: 'EventType', id: string, name_en: string, name_es: string, name_pt: string, description_en: string, description_es: string, description_pt: string }> };

export type ImpactsFilteredQueryVariables = Exact<{
  nameFragment: Scalars['String'];
}>;


export type ImpactsFilteredQuery = { __typename?: 'Query', impactAll: Array<{ __typename?: 'Impact', id: string, name_en: string, name_es: string, name_pt: string, impactType: { __typename?: 'ImpactType', id: string, name_en: string, name_es: string, name_pt: string } }> };

export type ImpactsQueryVariables = Exact<{ [key: string]: never; }>;


export type ImpactsQuery = { __typename?: 'Query', impactAll: Array<{ __typename?: 'Impact', id: string, name_en: string, name_es: string, name_pt: string, impactType: { __typename?: 'ImpactType', id: string, name_en: string, name_es: string, name_pt: string } }> };

export type ImpactTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ImpactTypesQuery = { __typename?: 'Query', impactTypeAll: Array<{ __typename?: 'ImpactType', id: string, name_en: string, name_es: string, name_pt: string }> };

export type InformationSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type InformationSourcesQuery = { __typename?: 'Query', informationSourceAll: Array<{ __typename?: 'InformationSource', id: string, name_en: string, name_es: string, name_pt: string }> };

export type InformationSourcesFilteredQueryVariables = Exact<{
  nameFragment: Scalars['String'];
}>;


export type InformationSourcesFilteredQuery = { __typename?: 'Query', informationSourceAll: Array<{ __typename?: 'InformationSource', id: string, name_en: string, name_es: string, name_pt: string }> };

export type OrganizationListQueryVariables = Exact<{
  where?: InputMaybe<OrganizationFilter>;
}>;


export type OrganizationListQuery = { __typename?: 'Query', organizationList: Array<{ __typename?: 'Organization', id: string, name: string, description: string, country: { __typename?: 'Country', id: string, name: string } }> };

export type RoleListQueryVariables = Exact<{
  where?: InputMaybe<RoleFilter>;
}>;


export type RoleListQuery = { __typename?: 'Query', roleList: Array<{ __typename?: 'Role', id: UserRole, name_es: string, name_en: string, name_pt: string }> };

export type StatesQueryVariables = Exact<{
  countryId: Scalars['String'];
  nameFragment?: InputMaybe<Scalars['String']>;
}>;


export type StatesQuery = { __typename?: 'Query', stateAll: Array<{ __typename?: 'State', id: string, name: string, latitude?: any | null, longitude?: any | null, country: { __typename?: 'Country', id: string, name: string } }> };

export type UserListQueryVariables = Exact<{
  where?: InputMaybe<UserFilter>;
  orderBy?: InputMaybe<Array<UserOrderBy> | UserOrderBy>;
  nextValueOfSortedColumn?: InputMaybe<Scalars['String']>;
  lastSortedColumn?: InputMaybe<Scalars['String']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type UserListQuery = { __typename?: 'Query', userList: Array<{ __typename?: 'User', id: string, name: string, email: string, active: boolean, roles: Array<{ __typename?: 'Role', id: UserRole, name_en: string, name_es: string, name_pt: string }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string, description: string, country: { __typename?: 'Country', name: string } }> } | null> };

export type NewUserMutationVariables = Exact<{
  email: Scalars['String'];
  name: Scalars['String'];
  active: Scalars['Boolean'];
  roles: Array<UserRole> | UserRole;
  organizations: Array<Scalars['String']> | Scalars['String'];
}>;


export type NewUserMutation = { __typename?: 'Mutation', userCreate: { __typename?: 'User', id: string } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  active: Scalars['Boolean'];
  roles?: InputMaybe<DependentRolesUpdate>;
  organizations?: InputMaybe<OrganizationsUpdate>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'User', id: string } };

export type UserResetPasswordMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type UserResetPasswordMutation = { __typename?: 'Mutation', userResetPassword: { __typename?: 'User', id: string } };

export type GetUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserQuery = { __typename?: 'Query', userOne: { __typename?: 'User', id: string, name: string, email: string, active: boolean, organizations: Array<{ __typename?: 'Organization', id: string, name: string, description: string, country: { __typename?: 'Country', id: string, name: string } }>, roles: Array<{ __typename?: 'Role', id: UserRole, name_en: string, name_es: string, name_pt: string, permissions?: Array<{ __typename?: 'Permission', id: string, name_en: string, name_es: string, name_pt: string }> | null }>, profile?: { __typename?: 'UserProfile', listProfile?: { __typename?: 'ListProfile', columnOrder?: Array<string> | null, VERSION: string, columnsInfo?: Array<{ __typename?: 'ColumnInfo', columnName: string, sortingEnabled: boolean, width: any, isHidden: boolean }> | null, sorting?: Array<{ __typename?: 'Sorting', columnName: string, direction: SortOrder }> | null } | null, reviewProfile?: { __typename?: 'ListProfile', columnOrder?: Array<string> | null, VERSION: string, columnsInfo?: Array<{ __typename?: 'ColumnInfo', columnName: string, sortingEnabled: boolean, width: any, isHidden: boolean }> | null, sorting?: Array<{ __typename?: 'Sorting', columnName: string, direction: SortOrder }> | null } | null } | null } };


export const LoginDocument = gql`
    query Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    token
  }
}
    `;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($oldPassword: String!, $newPassword: String!) {
  userChangePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
    id
  }
}
    `;
export const UpdateProfileDocument = gql`
    mutation UpdateProfile($profile: UserProfileInput!) {
  userUpdateProfile(profile: $profile) {
    id
  }
}
    `;
export const MeDocument = gql`
    query Me {
  me {
    id
    name
    email
    organizations {
      name
      country {
        id
        name
      }
    }
    roles {
      id
      name_en
      name_es
      name_pt
      permissions {
        id
        name_en
        name_es
        name_pt
      }
    }
    profile {
      listProfile {
        columnOrder
        columnsInfo {
          columnName
          sortingEnabled
          width
          isHidden
        }
        sorting {
          columnName
          direction
        }
        filter
        VERSION
      }
      reviewProfile {
        columnOrder
        columnsInfo {
          columnName
          sortingEnabled
          width
          isHidden
        }
        sorting {
          columnName
          direction
        }
        filter
        VERSION
      }
    }
  }
}
    `;
export const SaveProfileDocument = gql`
    mutation saveProfile($key: [String!]!, $value: Json!) {
  saveProfile(key: $key, value: $value)
}
    `;
export const CitiesDocument = gql`
    query Cities($countryId: String, $stateId: String, $nameFragment: String, $lastId: String, $pageSize: Int, $type: String) {
  cityPage(
    where: {AND: [{name: {contains: $nameFragment, mode: insensitive}}, {country: {id: {equals: $countryId}}}, {type: {contains: $type, mode: insensitive}}, {state: {id: {equals: $stateId}}}]}
    lastId: $lastId
    pageSize: $pageSize
  ) {
    id
    name
    type
    state {
      name
      id
    }
    latitude
    longitude
  }
}
    `;
export const FileUploadDocument = gql`
    mutation fileUpload($file: Upload!) {
  singleUpload(file: $file) {
    ticket
    filename
    mimetype
    encoding
  }
}
    `;
export const DeleteUploadedFileDocument = gql`
    mutation deleteUploadedFile($ticket: String!) {
  deleteUploadedFile(ticket: $ticket)
}
    `;
export const ConfidencesDocument = gql`
    query Confidences {
  confidenceAll {
    id
    name_en
    name_es
    name_pt
  }
}
    `;
export const NewEventDocument = gql`
    mutation NewEvent($eventTime: DateTime!, $sourceId: String!, $eventTypes: [String!]!, $temporalPrecisionSeg: Int, $totalDurationSeg: Int, $description: String, $miscellany: String, $references: [CreateReferenceLink!], $impacts: [String!], $images: [CreateEventImage!], $confidenceId: String, $content: String, $latitude: Decimal, $longitude: Decimal, $cityId: String, $stateId: String, $countryId: String, $spacialPrecisionMeters: Int, $location: String, $detailedLocation: String, $hailMaxDiameterMM: Float, $windSpeedKmH: Float, $windSpeedMaxKmH: Float, $windDirectionDegrees: Float, $precipitationAccumMM: Float, $snowAccumMM: Float) {
  eventCreate(
    eventTime: $eventTime
    sourceId: $sourceId
    eventTypes: $eventTypes
    temporalPrecisionSeg: $temporalPrecisionSeg
    totalDurationSeg: $totalDurationSeg
    description: $description
    miscellany: $miscellany
    references: $references
    impacts: $impacts
    images: $images
    confidenceId: $confidenceId
    content: $content
    latitude: $latitude
    longitude: $longitude
    cityId: $cityId
    stateId: $stateId
    countryId: $countryId
    spacialPrecisionMeters: $spacialPrecisionMeters
    location: $location
    detailedLocation: $detailedLocation
    hailMaxDiameterMM: $hailMaxDiameterMM
    windSpeedKmH: $windSpeedKmH
    windSpeedMaxKmH: $windSpeedMaxKmH
    windDirectionDegrees: $windDirectionDegrees
    precipitationAccumMM: $precipitationAccumMM
    snowAccumMM: $snowAccumMM
  ) {
    id
  }
}
    `;
export const UpdateEventDocument = gql`
    mutation UpdateEvent($id: String!, $eventTime: DateTime, $sourceId: String, $eventTypes: [String!], $temporalPrecisionSeg: Int, $totalDurationSeg: Int, $description: String, $miscellany: String, $references: UpdateReferenceChildren, $impacts: [String!], $images: UpdateImagesChildren, $confidenceId: String, $content: String, $latitude: Decimal, $longitude: Decimal, $cityId: String, $stateId: String, $countryId: String, $spacialPrecisionMeters: Int, $location: String, $detailedLocation: String, $hailMaxDiameterMM: Float, $windSpeedKmH: Float, $windSpeedMaxKmH: Float, $windDirectionDegrees: Float, $precipitationAccumMM: Float, $snowAccumMM: Float) {
  eventUpdate(
    id: $id
    eventTime: $eventTime
    sourceId: $sourceId
    eventTypes: $eventTypes
    temporalPrecisionSeg: $temporalPrecisionSeg
    totalDurationSeg: $totalDurationSeg
    description: $description
    miscellany: $miscellany
    references: $references
    impacts: $impacts
    images: $images
    confidenceId: $confidenceId
    content: $content
    latitude: $latitude
    longitude: $longitude
    cityId: $cityId
    stateId: $stateId
    countryId: $countryId
    spacialPrecisionMeters: $spacialPrecisionMeters
    location: $location
    detailedLocation: $detailedLocation
    hailMaxDiameterMM: $hailMaxDiameterMM
    windSpeedKmH: $windSpeedKmH
    windSpeedMaxKmH: $windSpeedMaxKmH
    windDirectionDegrees: $windDirectionDegrees
    precipitationAccumMM: $precipitationAccumMM
    snowAccumMM: $snowAccumMM
  ) {
    id
  }
}
    `;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($id: String!) {
  eventDeleted(id: $id) {
    id
    confidence {
      id
      name_es
      name_en
      name_pt
    }
    reviewer {
      id
      name
      email
    }
  }
}
    `;
export const VerifiedEventDocument = gql`
    mutation VerifiedEvent($id: String!) {
  eventReviewed(id: $id) {
    id
    confidence {
      id
      name_es
      name_en
      name_pt
    }
    reviewer {
      id
      name
      email
    }
  }
}
    `;
export const EventListDocument = gql`
    query EventList($where: EventFilter, $orderBy: [EventOrderBy!], $nextValueOfSortedColumn: String, $lastSortedColumn: String, $pageNumber: Int, $pageSize: Int) {
  eventList(
    where: $where
    orderBy: $orderBy
    nextValueOfSortedColumn: $nextValueOfSortedColumn
    lastSortedColumn: $lastSortedColumn
    pageNumber: $pageNumber
    pageSize: $pageSize
  ) {
    id
    eventTime
    eventTypes {
      id
      name_es
      name_en
      name_pt
    }
    temporalPrecisionSeg
    totalDurationSeg
    description
    references {
      id
      link
      description
    }
    impacts {
      id
      name_es
      name_en
      name_pt
    }
    source {
      id
      name_es
      name_en
      name_pt
    }
    confidence {
      id
      name_es
      name_en
      name_pt
    }
    validated
    images {
      id
      name
      description
    }
    author {
      name
      email
    }
    reviewer {
      name
      email
    }
    latitude
    longitude
    city {
      id
      name
      type
      latitude
      longitude
      state {
        id
        name
      }
    }
    state {
      id
      name
    }
    country {
      id
      name
    }
    spacialPrecisionMeters
    location
    detailedLocation
    hailMaxDiameterMM
    windSpeedKmH
    windSpeedMaxKmH
    windDirectionDegrees
    precipitationAccumMM
    snowAccumMM
  }
}
    `;
export const GetEventDocument = gql`
    query GetEvent($id: String!) {
  eventOne(id: $id) {
    id
    eventTime
    eventTypes {
      id
      name_es
      name_en
      name_pt
    }
    temporalPrecisionSeg
    totalDurationSeg
    description
    references {
      id
      link
      description
    }
    impacts {
      id
      name_es
      name_en
      name_pt
    }
    source {
      id
      name_es
      name_en
      name_pt
    }
    confidence {
      id
      name_es
      name_en
      name_pt
    }
    validated
    images {
      id
      name
      description
    }
    author {
      id
      name
      email
      roles {
        id
        name_es
        name_en
        name_pt
      }
      organizations {
        id
        name
        description
        country {
          name
        }
        webpage
      }
    }
    reviewer {
      id
      name
      email
    }
    latitude
    longitude
    city {
      id
      name
      type
      latitude
      longitude
      state {
        id
        name
      }
    }
    state {
      id
      name
    }
    country {
      id
      name
    }
    spacialPrecisionMeters
    location
    detailedLocation
    hailMaxDiameterMM
    windSpeedKmH
    windSpeedMaxKmH
    windDirectionDegrees
    precipitationAccumMM
    snowAccumMM
  }
}
    `;
export const EventTypesDocument = gql`
    query EventTypes {
  eventTypeAll {
    id
    name_en
    name_es
    name_pt
    description_en
    description_es
    description_pt
  }
}
    `;
export const ImpactsFilteredDocument = gql`
    query ImpactsFiltered($nameFragment: String!) {
  impactAll(
    where: {OR: [{name_en: {contains: $nameFragment, mode: insensitive}}, {name_es: {contains: $nameFragment, mode: insensitive}}, {name_pt: {contains: $nameFragment, mode: insensitive}}, {impactType: {name_en: {contains: $nameFragment, mode: insensitive}}}, {impactType: {name_es: {contains: $nameFragment, mode: insensitive}}}, {impactType: {name_pt: {contains: $nameFragment, mode: insensitive}}}]}
  ) {
    id
    name_en
    name_es
    name_pt
    impactType {
      id
      name_en
      name_es
      name_pt
    }
  }
}
    `;
export const ImpactsDocument = gql`
    query Impacts {
  impactAll {
    id
    name_en
    name_es
    name_pt
    impactType {
      id
      name_en
      name_es
      name_pt
    }
  }
}
    `;
export const ImpactTypesDocument = gql`
    query ImpactTypes {
  impactTypeAll {
    id
    name_en
    name_es
    name_pt
  }
}
    `;
export const InformationSourcesDocument = gql`
    query InformationSources {
  informationSourceAll {
    id
    name_en
    name_es
    name_pt
  }
}
    `;
export const InformationSourcesFilteredDocument = gql`
    query InformationSourcesFiltered($nameFragment: String!) {
  informationSourceAll(
    where: {OR: [{name_en: {contains: $nameFragment, mode: insensitive}}, {name_es: {contains: $nameFragment, mode: insensitive}}, {name_pt: {contains: $nameFragment, mode: insensitive}}]}
  ) {
    id
    name_en
    name_es
    name_pt
  }
}
    `;
export const OrganizationListDocument = gql`
    query OrganizationList($where: OrganizationFilter) {
  organizationList(where: $where) {
    id
    name
    description
    country {
      id
      name
    }
  }
}
    `;
export const RoleListDocument = gql`
    query RoleList($where: RoleFilter) {
  roleList(where: $where) {
    id
    name_es
    name_en
    name_pt
  }
}
    `;
export const StatesDocument = gql`
    query States($countryId: String!, $nameFragment: String) {
  stateAll(
    where: {AND: [{name: {contains: $nameFragment, mode: insensitive}}, {country: {id: {equals: $countryId}}}]}
  ) {
    id
    name
    country {
      id
      name
    }
    latitude
    longitude
  }
}
    `;
export const UserListDocument = gql`
    query UserList($where: UserFilter, $orderBy: [UserOrderBy!], $nextValueOfSortedColumn: String, $lastSortedColumn: String, $pageNumber: Int, $pageSize: Int) {
  userList(
    where: $where
    orderBy: $orderBy
    nextValueOfSortedColumn: $nextValueOfSortedColumn
    lastSortedColumn: $lastSortedColumn
    pageNumber: $pageNumber
    pageSize: $pageSize
  ) {
    id
    name
    email
    active
    roles {
      id
      name_en
      name_es
      name_pt
    }
    organizations {
      id
      name
      description
      country {
        name
      }
    }
  }
}
    `;
export const NewUserDocument = gql`
    mutation NewUser($email: String!, $name: String!, $active: Boolean!, $roles: [UserRole!]!, $organizations: [String!]!) {
  userCreate(
    email: $email
    name: $name
    active: $active
    roles: $roles
    organizations: $organizations
  ) {
    id
  }
}
    `;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: String!, $email: String, $name: String, $active: Boolean!, $roles: DependentRolesUpdate, $organizations: OrganizationsUpdate) {
  userUpdate(
    id: $id
    email: $email
    name: $name
    active: $active
    roles: $roles
    organizations: $organizations
  ) {
    id
  }
}
    `;
export const UserResetPasswordDocument = gql`
    mutation UserResetPassword($id: String!) {
  userResetPassword(id: $id) {
    id
  }
}
    `;
export const GetUserDocument = gql`
    query GetUser($id: String!) {
  userOne(id: $id) {
    id
    name
    email
    active
    organizations {
      id
      name
      description
      country {
        id
        name
      }
    }
    roles {
      id
      name_en
      name_es
      name_pt
      permissions {
        id
        name_en
        name_es
        name_pt
      }
    }
    profile {
      listProfile {
        columnOrder
        columnsInfo {
          columnName
          sortingEnabled
          width
          isHidden
        }
        sorting {
          columnName
          direction
        }
        VERSION
      }
      reviewProfile {
        columnOrder
        columnsInfo {
          columnName
          sortingEnabled
          width
          isHidden
        }
        sorting {
          columnName
          direction
        }
        VERSION
      }
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Login(variables: LoginQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoginQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginQuery>(LoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Login', 'query');
    },
    ChangePassword(variables: ChangePasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ChangePasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChangePasswordMutation>(ChangePasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ChangePassword', 'mutation');
    },
    UpdateProfile(variables: UpdateProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateProfileMutation>(UpdateProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateProfile', 'mutation');
    },
    Me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>(MeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Me', 'query');
    },
    saveProfile(variables: SaveProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SaveProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SaveProfileMutation>(SaveProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'saveProfile', 'mutation');
    },
    Cities(variables?: CitiesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CitiesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CitiesQuery>(CitiesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Cities', 'query');
    },
    fileUpload(variables: FileUploadMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FileUploadMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FileUploadMutation>(FileUploadDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'fileUpload', 'mutation');
    },
    deleteUploadedFile(variables: DeleteUploadedFileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteUploadedFileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUploadedFileMutation>(DeleteUploadedFileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteUploadedFile', 'mutation');
    },
    Confidences(variables?: ConfidencesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ConfidencesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ConfidencesQuery>(ConfidencesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Confidences', 'query');
    },
    NewEvent(variables: NewEventMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NewEventMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<NewEventMutation>(NewEventDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NewEvent', 'mutation');
    },
    UpdateEvent(variables: UpdateEventMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateEventMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateEventMutation>(UpdateEventDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateEvent', 'mutation');
    },
    DeleteEvent(variables: DeleteEventMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteEventMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteEventMutation>(DeleteEventDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DeleteEvent', 'mutation');
    },
    VerifiedEvent(variables: VerifiedEventMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VerifiedEventMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<VerifiedEventMutation>(VerifiedEventDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VerifiedEvent', 'mutation');
    },
    EventList(variables?: EventListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EventListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EventListQuery>(EventListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EventList', 'query');
    },
    GetEvent(variables: GetEventQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEventQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEventQuery>(GetEventDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetEvent', 'query');
    },
    EventTypes(variables?: EventTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EventTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EventTypesQuery>(EventTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EventTypes', 'query');
    },
    ImpactsFiltered(variables: ImpactsFilteredQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ImpactsFilteredQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImpactsFilteredQuery>(ImpactsFilteredDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ImpactsFiltered', 'query');
    },
    Impacts(variables?: ImpactsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ImpactsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImpactsQuery>(ImpactsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Impacts', 'query');
    },
    ImpactTypes(variables?: ImpactTypesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ImpactTypesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ImpactTypesQuery>(ImpactTypesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ImpactTypes', 'query');
    },
    InformationSources(variables?: InformationSourcesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InformationSourcesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InformationSourcesQuery>(InformationSourcesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InformationSources', 'query');
    },
    InformationSourcesFiltered(variables: InformationSourcesFilteredQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<InformationSourcesFilteredQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<InformationSourcesFilteredQuery>(InformationSourcesFilteredDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'InformationSourcesFiltered', 'query');
    },
    OrganizationList(variables?: OrganizationListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrganizationListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrganizationListQuery>(OrganizationListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'OrganizationList', 'query');
    },
    RoleList(variables?: RoleListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RoleListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RoleListQuery>(RoleListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RoleList', 'query');
    },
    States(variables: StatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StatesQuery>(StatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'States', 'query');
    },
    UserList(variables?: UserListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserListQuery>(UserListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserList', 'query');
    },
    NewUser(variables: NewUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NewUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<NewUserMutation>(NewUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NewUser', 'mutation');
    },
    UpdateUser(variables: UpdateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserMutation>(UpdateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUser', 'mutation');
    },
    UserResetPassword(variables: UserResetPasswordMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserResetPasswordMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserResetPasswordMutation>(UserResetPasswordDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserResetPassword', 'mutation');
    },
    GetUser(variables: GetUserQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetUserQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetUserQuery>(GetUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetUser', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;